<script lang="ts">
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import {createEventDispatcher} from "svelte";

    export let cargaMaestra: any;
    export let backLabel = 'ACEPTAR';
    const dispatch = createEventDispatcher();
</script>

{#if cargaMaestra}
    <div>
        <div class="fieldset-header back-secondary px-15 py-ii">
            <strong class="white">Información de la Carga</strong>
        </div>
        <div class="mt-i mb-2">
            <table class="naui-table w-100">
                <tr>
                    <th>
                        <div>
                            Archivo
                        </div>
                    </th>
                    <td>
                        <div>
                            <NauiButton href="{cargaMaestra.file}"
                                        caption="Descargar"
                                        icon="download"/>
                        </div>
                    </td>
                </tr>
                <tr>
                    <th>
                        <div>Total filas procesadas:</div>
                    </th>
                    <td>
                        <div>{cargaMaestra?.total_records}</div>
                    </td>
                </tr>
                <tr>
                    <th>
                        <div>Total errores presentados:</div>
                    </th>
                    <td>
                        <div>{cargaMaestra?.error_records}</div>
                    </td>
                </tr>
            </table>
        </div>
        {#if cargaMaestra?.errors?.errors?.length > 0}
            <div class="mb-ii">
                <fieldset>
                    <legend>Errores Generales</legend>
                    <div style="max-height: 400px; overflow-y: auto">
                        <table class="naui-table w-100">
                            <thead>
                            <tr>
                                <th>
                                    <div>Detalle</div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {#each cargaMaestra.errors.errors as row}
                                <tr>
                                    <td>
                                        <div>{row ?? ''}</div>
                                    </td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    </div>
                </fieldset>
            </div>
        {/if}
        {#if cargaMaestra?.errors?.rows?.length > 0}
            <div class="mb-ii">
                <fieldset>
                    <legend>Errores por fila</legend>
                    <div style="max-height: 400px; overflow-y: auto">
                        <table class="naui-table w-100">
                            <thead>
                            <tr>
                                <th>
                                    <div>Fila</div>
                                </th>
                                <th>
                                    <div>Detalle</div>
                                </th>
                            </tr>
                            </thead>
                            <tbody>
                            {#each cargaMaestra.errors.rows as row}
                                <tr>
                                    <td>
                                        <div>{row?.row}</div>
                                    </td>
                                    <td>
                                        <div>{row?.error ?? ''}</div>
                                    </td>
                                </tr>
                            {/each}
                            </tbody>
                        </table>
                    </div>
                </fieldset>
            </div>
        {/if}
    </div>
{/if}
<NauiButton caption="{backLabel}"
            mode="outline"
            color="accent"
            on:click={()=>dispatch('back')}/>

<style>
    .fieldset-header {
        border-radius: 5px 5px 0 0;
    }
</style>